import { ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { Appointment } from '../../../landing/models';
import moment from 'moment';
import { Globals } from '../../../globals';
import { HomeAccordionService } from '../controls/home-accordion/home-accordion.service';
import { fromEvent, Subscription } from 'rxjs';
import { MessagingService } from '../../../services/messaging.service';
import { StaticDataService } from '../../../services/static-data.service';
import { DoctorDataModel } from '../../../models/doctors/doctor-data.model';
import { MessagingConstants } from '../../../models/MessagingConstants';
import { TemplatePortal } from '@angular/cdk/portal';
import { filter, take } from 'rxjs/operators';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { DialogService } from '../../../services/dialog.service';
import { PatientFlagDataModel } from '../../../models/patient/patient-flag-data.model';
import { AppointmentFlagDataModel } from '../../../models/appointments/appointment-flag-data.model';
import { EnumValidValueItemModel } from '../../../models/enum/enum-valid-value-item.model';
import { TdoDropdownChange } from '../../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';
import { LocalStorageService } from '../../../services/local-storage.service';
import { SchedulingService } from '../../../modules/scheduling/scheduling.service';
import { UiService } from 'src/app/services/ui.service';
import { TdoDropdownV2Component } from 'src/app/tdo-controls/common/tdo-dropdown-v2/tdo-dropdown-v2.component';


@Component({
  standalone: false,
    selector: 'app-home-schedule-view',
    templateUrl: './home-schedule-view.component.html',
    styleUrls: ['./home-schedule-view.component.css']
})
export class HomeScheduleViewComponent implements OnInit, OnDestroy {
    @ViewChild('ctxMenu') contextMenu: TemplateRef<any>;
    @ViewChild('doctorScheduleDropdown') doctorScheduleDropdown: TdoDropdownV2Component;
    @Output() requestClose = new EventEmitter();
    @Output() requestCheckOut = new EventEmitter();
    @Output() accordionClose = new EventEmitter<void>();


    doctorPredicate: (data: DoctorDataModel) => string;

    currAndFutureAppointments: Appointment[] = [];
    filteredAppointments: Appointment[] = [];
    selectedAppointmentId: string;
    scheduleDate: moment.Moment;
    today: moment.Moment = moment();
    subscriptions: Subscription[] = [];
    appointmentFlagEnums: EnumValidValueItemModel[];
    patientFlagEnums: EnumValidValueItemModel[];
    isCheckedIn: boolean = false;
    isCheckedOut: boolean = false;
    selectedDoctor: DoctorDataModel | null = null;

    private overlayRef: OverlayRef | null;
    private sub: Subscription;
    isContextOpen = false;

    constructor(private readonly router: Router,
        private readonly globals: Globals,
        private readonly homeAccordionService: HomeAccordionService,
        private readonly messagingService: MessagingService,
        private readonly overlay: Overlay,
        private readonly viewContainerRef: ViewContainerRef,
        private readonly dialogService: DialogService,
        public readonly staticDataService: StaticDataService,
        private readonly localStorageService: LocalStorageService,
        private readonly schedulingService: SchedulingService,
        private readonly cdr: ChangeDetectorRef,
        private readonly uiService: UiService
    ) { }

    ngOnInit(): void {
        this.doctorPredicate = (data: DoctorDataModel) => 'Dr. ' + data.dataContact.LastName;
        const dateSub = this.homeAccordionService.changeDateEvent.subscribe({
            next: (appointments) => {
                this.currAndFutureAppointments = appointments;
                if (this.selectedDoctor) {
                    this.filteredAppointments = this.currAndFutureAppointments.filter(p => p?.DoctorId?.toLowerCase() === this.selectedDoctor?.DoctorId?.toLowerCase());
                }
                else
                    this.filteredAppointments = appointments;
                // if (this.localStorageService.loggedInDoctorId) {
                //     // console.log('loggedInDoctorId', this.localStorageService.loggedInDoctorId);
                //     // const ivl = setInterval(() => {
                //     //     if (this.staticDataService.currentLocationDoctors && this.staticDataService.currentLocationDoctors.length > 0) {
                //     //         clearInterval(ivl);
                //     //         this.selectedDoctor = this.staticDataService.currentLocationDoctors.find(p => p?.DoctorId?.toLowerCase() === this.localStorageService.loggedInDoctorId?.toLowerCase());
                //     //         if (this.selectedDoctor) {
                //     //             this.filteredAppointments = this.currAndFutureAppointments.filter(p => p?.DoctorId?.toLowerCase() === this.selectedDoctor.DoctorId.toLowerCase());
                //     //         } else {
                //     //             this.filteredAppointments = this.currAndFutureAppointments;
                //     //         }
                //     //         const count = this.filteredAppointments.length;
                //     //         this.homeAccordionService.numScheduleItems = count;
                //     //         this.cdr.detectChanges();
                //     //     }
                //     // }, 100);
                // }

                const count = this.filteredAppointments.length;
                setTimeout(() => {
                    this.homeAccordionService.numScheduleItems = count;
                    this.scheduleDate = this.homeAccordionService.scheduleDate;
                    this.cdr.detectChanges();
                }, 0);
            }
        });
        this.subscriptions.push(dateSub);

        if (this.homeAccordionService.currAndFutureAppointments) {
            this.currAndFutureAppointments = this.homeAccordionService.currAndFutureAppointments;
            this.filteredAppointments = this.currAndFutureAppointments;

            if (this.localStorageService.loggedInDoctorId) {
                const ivl = setInterval(() => {
                    if (this.staticDataService.currentLocationDoctors && this.staticDataService.currentLocationDoctors.length > 0) {
                        clearInterval(ivl);
                        this.selectedDoctor = this.staticDataService.currentLocationDoctors.find(p => p?.DoctorId?.toLowerCase() === this.localStorageService.loggedInDoctorId?.toLowerCase());
                        if (this.selectedDoctor) {
                            this.filteredAppointments = this.currAndFutureAppointments.filter(p => p?.DoctorId?.toLowerCase() === this.selectedDoctor?.DoctorId?.toLowerCase());
                        } else {
                            this.filteredAppointments = this.currAndFutureAppointments;
                        }
                        const count = this.filteredAppointments.length;
                        this.homeAccordionService.numScheduleItems = count;
                        this.cdr.detectChanges();
                    }
                }, 100);
            }
        }

        if (this.staticDataService.isReady) {
            this.setupEnums();
        } else {
            this.staticDataService.validValuesReadyEvent.subscribe({
                complete: () => {
                    this.setupEnums();
                }
            });
        }
    }

    setupEnums() {
        this.appointmentFlagEnums = this.staticDataService.getValidValueItemsByValidValueName('enumAppoitmentFlag');
        this.patientFlagEnums = this.staticDataService.getValidValueItemsByValidValueName('enumPatientFlag');
    }

    ngOnDestroy(): void {
        for (const sub of this.subscriptions) {
            if (sub)
            sub.unsubscribe();
        }
    }

    changePatient(appointment: Appointment) {
        this.messagingService.broadCastMessage(MessagingConstants.PATIENT_CHANGED, {
            PatientID: appointment.PatientId,
            PatientName: appointment.PatientName,
            clearCurrentQuery: false
        });

        this.requestClose.emit();
    }

    onDoctorSelect(doctor: DoctorDataModel) {
        // console.log('Doctor selected: ' + doctor.dataContact.FirstName);
    }

    onScheduleIconClick() {
        this.uiService.openSchedulerWindow();      
    }

    getStartTime(appointment: Appointment) {
        const startTime = new Date(appointment.StartDateTime);
        let hours = startTime.getHours();
        let demarcation = 'AM';
        if (hours > 12) {
            hours -= 12;
            demarcation = 'PM';
        }

        const minutes = startTime.getMinutes();
        let minutesString = minutes.toString();
        if (minutes < 10) {
            minutesString = '0' + minutes.toString();
        }

        return hours + ':' + minutesString + ' ' + demarcation;
    }

    getDuration(appointment: Appointment) {
        const endTimeMs = new Date(appointment.EndDateTime).getTime();
        const startTimeMs = new Date(appointment.StartDateTime).getTime();
        const diffMs = endTimeMs - startTimeMs;

        const minutes = diffMs / 1000 / 60;
        let hours = 0;
        let minutesString = minutes.toString();
        if (minutes >= 60) {
            hours = Math.floor(minutes / 60);
            minutesString = (minutes % 60).toString();
        }

        if (hours >= 1) {
            if (hours === 1) {
                return hours.toString() + ' Hour ' + minutesString + ' Min';
            } else {
                return hours.toString() + ' Hours ' + minutesString + ' Min';
            }
        } else {
            return minutesString + ' Min';
        }
    }

    getOperatoryImage(operatoryId: string) {
        if (!this.staticDataService.currentLocationOperatories) {
            return;
        }

        const op = this.staticDataService.currentLocationOperatories.find(p => p.OperatoryId === operatoryId);
        if (op) {
            return op.avatar;
        } else {
            return null;
        }
    }

    getOperatoryName(operatoryId: string) {
        if (!this.staticDataService.currentLocationOperatories) {
            return;
        }

        const op = this.staticDataService.currentLocationOperatories.find(p => p.OperatoryId === operatoryId);
        if (op) {
            return op.OperatoryName;
        } else {
            return null;
        }
    }

    onPatientContextMenu(event: MouseEvent, appt: Appointment) {
        this.openContext(event, this.contextMenu, appt);
    }

    // Context menu
    // Context boilerplate
    openContext({ x, y }: MouseEvent, template: TemplateRef<any>, data: any, closeOnItemClick = true): void {
        this.isContextOpen = true;
        this.closeContext();
        x = x + 50;
        y = y - 20;
        const positionStrategy = this.overlay.position().flexibleConnectedTo({ x, y }).withPositions([
            {
                originX: 'end',
                originY: 'bottom',
                overlayX: 'end',
                overlayY: 'top'
            }
        ]);

        this.overlayRef = this.overlay.create({
            positionStrategy,
            scrollStrategy: this.overlay.scrollStrategies.close()
        });

        this.overlayRef.attach(new TemplatePortal(template, this.viewContainerRef, { $implicit: data }));

        this.sub = fromEvent<MouseEvent>(document, 'click')
            .pipe(
                filter(event => {
                    if (closeOnItemClick) {
                        this.closeContext();
                    } else {
                        const clickTarget = event.target as HTMLElement;
                        return !!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget);
                    }
                }), take(1)).subscribe(() => this.closeContext());
    }

    closeContext(): void {
        this.sub !== undefined && this.sub.unsubscribe();
        if (this.overlayRef) {
            this.isContextOpen = false;
            this.overlayRef.dispose();
            this.overlayRef = null;
        }
    }

    onCheckInPatient(event: Event, appointment: Appointment) {
        event.stopPropagation();
        this.closeContext();
        this.requestClose.emit();
        this.dialogService.openPatientCheckInDialog(appointment).subscribe((res) => {
            if (res) {
                this.currAndFutureAppointments.find(x => x.AppointmentId === appointment.AppointmentId).isCheckedIn = true;
            }
        });
    }

    getPatientFlagImage(flag: PatientFlagDataModel) {
        if (this.patientFlagEnums) {
            const enu = this.patientFlagEnums.find(p => p.ValidValueItemId.toLowerCase() === flag.enumPatientFlagID.toLowerCase());
            if (enu) {
                return enu.IconIDSVG;
            }
        }
    }

    getPatientFlagTooltip(flag: PatientFlagDataModel) {

        if (this.patientFlagEnums) {
            const enu = this.patientFlagEnums.find(p => p.ValidValueItemId.toLowerCase() === flag.enumPatientFlagID.toLowerCase());
            if (enu) {
                return enu.ItemDisplayValue;
            }
        }
        return '';
    }

    getAppointmentFlagImage(flag: AppointmentFlagDataModel) {
        if (this.appointmentFlagEnums) {

            const enu = this.appointmentFlagEnums.find(p => p.ValidValueItemId.toLowerCase() === flag.enumAppoitmentFlagID.toLowerCase());
            if (enu) {
                return enu.IconIDSVG;
            }
        }
    }

    getAppointmentFlagTooltip(flag: AppointmentFlagDataModel) {
        if (this.appointmentFlagEnums) {
            const enu = this.appointmentFlagEnums.find(p => p.ValidValueItemId.toLowerCase() === flag.enumAppoitmentFlagID.toLowerCase());
            if (enu) {
                return enu.ItemDisplayValue;
            }
        }

        return '';
    }
    onCheckOutPatient(event: Event, appointment: Appointment) {
        event.stopPropagation();
        this.closeContext();
        this.messagingService.broadCastMessage(MessagingConstants.PATIENT_CHANGED, {
            PatientID: appointment.PatientId,
            PatientName: appointment.PatientName,
            Process: MessagingConstants.CHECKOUT_PATIENT_START,
            PatientCaseId: appointment.PatientCaseId,
            clearCurrentQuery: false
        });
        this.accordionClose.emit();
    }

    getBackgroundColor(appt: Appointment) {
        if (appt.isDeceased) {
            return '#a4b589';
        } else if (appt.isDoNotEverTreatAgain) {
            return '#b58989';
        }
    }

    onDoctorSelected(event: TdoDropdownChange) {
        if (event.value) {
            this.filteredAppointments = this.currAndFutureAppointments.filter(p => p?.DoctorId?.toLowerCase() === event.value?.DoctorId?.toLowerCase());
            const count = this.filteredAppointments.length;
            setTimeout(() => {
                this.homeAccordionService.numScheduleItems = count;
                this.cdr.markForCheck();
            }, 0);
        }
    }

    onClearDoctor() {
        this.selectedDoctor = null;
        this.filteredAppointments = this.currAndFutureAppointments;
        const count = this.filteredAppointments.length;
        setTimeout(() => {
            this.selectedDoctor = null;
            this.doctorScheduleDropdown.clearSelection();
            this.homeAccordionService.numScheduleItems = count;
            this.cdr.markForCheck();
        }, 0);
    }
}
